<template>
    <tenancies-update
        :uuid="tenancy.uuid"
        @success="show_edit_modal = false; show_updated_modal = true"
    >
        <div
            slot-scope="{
                sid,
                is_loading: is_saving,
                error,
                update,
                forget
            }"
        >
            <error-modal
                v-if="error && $error.is(error, { exclude: [422] })"
                :error="error"
                @close="forget"
            />

            <modal-success
                v-else-if="show_updated_modal"
                :is-open="show_updated_modal"
                @close="closeAll(); $emit('success')"
            >
                <template slot="heading">Tenancy Updated!</template>

                <p>The term for this tenancy has been extended.</p>

                <div
                    slot="footer"
                    slot-scope="{ close }"
                    class="flex flex-col md:flex-row-reverse"
                >
                    <button
                        type="button"
                        @click.prevent="close"
                        class="text-center btn"
                    >
                        Close
                    </button>
                </div>
            </modal-success>

            <modal-blue
                v-else-if="show_edit_modal"
                :is-open="show_edit_modal"
                @close="closeAll"
            >
                <base-form
                    slot-scope="{ close }"
                    @submit="update(form)"
                >
                    <div class="px-4 pt-6 border-b sm:px-6">
                        <h6 class="mb-3 text-lg font-normal font-semibold text-center">
                            Extend Term
                        </h6>

                        <div class="mb-6 text-grey-darker">
                            <p>If you would like to allow your tenants to make payments against rents beyond the current period, you'll need to extend the term - we'll create rents up to that date.</p>
                        </div>

                        <validator-alert :sid="sid" />

                        <grid-layout>
                            <grid-layout-item>
                                <form-item
                                    :sid="sid"
                                    :is-required="true"
                                    name="ends_at"
                                >
                                    <template slot="label">Ends</template>

                                    <input-select
                                        v-model="form.ends_at"
                                        :options="options"
                                        :sid="sid"
                                        name="ends_at"
                                    />
                                </form-item>
                            </grid-layout-item>
                        </grid-layout>
                    </div>

                    <footer class="flex flex-col px-6 py-3 rounded-b md:flex-row-reverse bg-grey-bg">
                        <base-button
                            :is-loading="is_saving"
                            type="submit"
                            class="w-full btn btn-blue md:w-auto"
                        >
                            Update Tenancy
                        </base-button>

                        <button
                            type="button"
                            class="text-center btn md:mr-3"
                            @click.prevent="close"
                        >
                            Cancel
                        </button>
                    </footer>
                </base-form>
            </modal-blue>
        </div>
    </tenancies-update>
</template>

<script>
    import _ from 'lodash'
    import moment from 'moment'
    import TenanciesUpdate from '../../../../../../components/tenancies-update'

    export default {
        components: {
            TenanciesUpdate
        },
        model: {
            prop: 'toggled',
            event: 'toggle'
        },
        props: {
            toggled: {
                type: Boolean,
                required: true
            },
            tenancy: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                show_edit_modal: this.toggled,
                show_updated_modal: false,
                form: {
                    ends_at: _.chain(this.tenancy.ends_at)
                        .thru(value => {
                            if (!value) {
                                return value
                            }

                            return moment(value).add(1, 'month').format('DD/MM/YYYY')
                        })
                        .value()
                }
            }
        },
        computed: {
            options () {
                return _.map(_.range(1, 13), i => {
                    const date = this.$moment(this.tenancy.ends_at).hour(12).add(i, 'month')

                    return {
                        label: date.format('DD MMM YYYY'),
                        sublabel: `+${i} month` + (i > 1 ? 's' : ''),
                        value: date.format('DD/MM/YYYY')
                    }
                })
            }
        },
        watch: {
            toggled () {
                this.show_edit_modal = this.toggled
            }
        },
        methods: {
            closeAll () {
                this.show_updated_modal = false
                this.show_edit_modal = false

                this.$emit('toggle', false)
            },
            onSuccess () {
                this.show_edit_modal = false
                this.show_updated_modal = true
            }
        }
    }
</script>
